export default "__VITE_ASSET__D28TC6uy__"